/**
 * "A, B, C" for a chip's summary label, or undefined when the short label
 * already says it all: no names yet, or one name with nothing else selected.
 * `conditions` counts the selection's non-name criteria (departments, roles,
 * install age, ...), which are noted rather than named.
 */
export function listNames(names: string[], conditions = 0): string | undefined {
  const unique = [...new Set(names)];
  if (unique.length === 0 || (unique.length === 1 && conditions === 0)) {
    return undefined;
  }
  return conditions > 0
    ? `${unique.join(", ")} (+${conditions} more condition${conditions === 1 ? "" : "s"})`
    : unique.join(", ");
}
